import Component from 'vue-class-component';
import { AppVue } from '../../../app.vue';
import { mapState, mapMutations } from 'vuex';
import './menu.scss';

@Component({
    template: require('./menu.html'),
    name: 'Menu',
    props: {
        platformMenu: {
            type: Array,
        }
    },
    computed: {
        ...mapState(['selectkey']),
    },
})
export class Menu extends AppVue {

    ScWidth:number
    created() {
        this.ScWidth=screen.width
        console.log(screen.width)
        // return {};
    }
    jump(url){
        // sessionStorage.setItem('pg','1');
        this.hrefTo(url);
        
    }
}